import type { SellCabinBaggageNew, SellSpecificationBaggageNew } from '@eti/schema-types';
import { cabinBaggage, checkInBaggage } from '@eti/products';
import { price } from '@eti/utils';
import type {
  AvailableExtraProductsType,
  PossibleToAddProductType,
  SellSpecificationType,
} from '../../../../models';

const CHECKED_BAGGAGE_PRODUCT_ID = checkInBaggage.id;
const CABIN_BAGGAGE_PRODUCT_ID = cabinBaggage.id;

export const possibleToAddBaggages = (availableExtraProducts: AvailableExtraProductsType) => {
  const listOfPossibleToAdd: PossibleToAddProductType[] = [];
  let hasCheckInBaggage = false;
  let hasCabinBaggage = false;
  const checkedBaggageProduct = availableExtraProducts.find(
    (baggage) =>
      Number(baggage.productId) === CHECKED_BAGGAGE_PRODUCT_ID &&
      baggage.sellSpecification.__typename === 'SellSpecificationBaggageNew' &&
      (baggage.sellSpecification as SellSpecificationBaggageNew).sellPriceBaggage?.[0],
  );

  const cabinBaggageProduct = availableExtraProducts.find(
    (baggage) =>
      Number(baggage.productId) === CABIN_BAGGAGE_PRODUCT_ID &&
      baggage.sellSpecification.__typename === 'SellCabinBaggageNew' &&
      (baggage.sellSpecification as SellCabinBaggageNew).sellPriceTravelers?.[0],
  );

  if (checkedBaggageProduct) {
    hasCheckInBaggage = true;
    listOfPossibleToAdd.push({
      ...checkedBaggageProduct,
      baggageText: 'Result.Baggage.CheckedBaggage.Text',
      baggageIconId: 'check-in-baggage',
    });
  }

  if (cabinBaggageProduct) {
    hasCabinBaggage = true;
    listOfPossibleToAdd.push({
      ...cabinBaggageProduct,
      baggageText: 'Result.Baggage.CabinBaggage.Text',
      baggageIconId: 'cabin-baggage',
    });
  }

  return {
    listOfPossibleToAdd,
    hasCheckInBaggage,
    hasCabinBaggage,
  };
};

export const getBaggageSpecificationDetails = (baggage: SellSpecificationType) => {
  if (baggage.__typename === 'SellCabinBaggageNew') {
    const cabinBaggageSellSpecification = baggage.sellPriceTravelers[0];
    return {
      weight: baggage.weight,
      weightUnit: baggage.weightUnit,
      startingFromPrice: price.formatPrice(cabinBaggageSellSpecification?.price?.price?.value),
    };
  }
  if (baggage.__typename === 'SellSpecificationBaggageNew') {
    const checkedBaggageSellSpecification = baggage.sellPriceBaggage[0];

    return {
      weight: checkedBaggageSellSpecification?.maxWeight,
      weightUnit: checkedBaggageSellSpecification?.weightUnit,
      startingFromPrice: price.formatPrice(checkedBaggageSellSpecification?.price?.price?.value),
    };
  }
  return null;
};
